module.exports = __webpack_public_path__ + "static/7_email_marketing-e61927b0d02215298b21e0b2c829db44.webp";